import { render } from "./EasPassagePage.vue?vue&type=template&id=23ac3a9e"
import script from "./EasPassagePage.vue?vue&type=script&lang=js"
export * from "./EasPassagePage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src999357143/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__